import { Box } from "@mui/material";
import { RightBlockLogin } from "./RightBlockLogin";
import "./styles/style.css";

const LogIn = ({ children }) => {
  return (
    <Box className="login_wrapper">
      <Box className="right_block">
        {children}
      </Box>
      <RightBlockLogin />
    </Box>
  );
};

export default LogIn;
